import { Button, CircularProgress, Grid } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import REACT_APP from "../../environment";
import axios from "axios";
import regex from "tts-hrp-val-lib";
import { useTranslation } from "react-i18next";

const AddBranches = ({ getDate }) => {
    const { t } = useTranslation();
    const [countryValue, setCountryValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [country, setCountry] = useState([]);
    const [regions, setRegions] = useState([]);
    const closeRef = useRef(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
    } = useForm();

    const getCountry = () => {
        axios(`${REACT_APP.COMMON_API}/tts/api/v01/countries`, {
            headers: { "client-id": REACT_APP.COMMON_ID, secret: REACT_APP.COMMON_SECRET },
        })
            .then((res) => setCountry(res.data.data))
            .catch((err) => {});
    };

    const getRegions = () => {
        axios(`${REACT_APP.COMMON_API}/tts/api/v01/region/14ed6cfc-d787-45ba-b44d-84ac06e37935`, {
            headers: { "client-id": REACT_APP.COMMON_ID, secret: REACT_APP.COMMON_SECRET },
        })
            .then((res) => setRegions(res.data.data))
            .catch((err) => {});
    };

    const Submit = async (date) => {
        let body = {
            name: date.name,
            email: date.email,
            phone: date.phone,
            address: {
                country: date.country,
                city: date.city,
                region: date.region,
                address1: date.address1,
                address2: date.address2 ? date.address2 : undefined,
                zip_code: date.zip_code ? date.zip_code : undefined,
            },
        };
        setLoading(true);
        axios
            .post(`${REACT_APP.URL}/api/hrp/v1/branch`, body, { headers: { Authorization: sessionStorage.getItem("token") } })
            .then((res) => {
                setLoading(false);
                reset();
                getDate();
                closeRef.current.click();
                toast.success(t("Success"));
            })
            .catch((err) => {
                setLoading(false);
                toast.error(t("Something went wrong"));
            });
    };

    useEffect(() => {
        getCountry();
        getRegions();
    }, []);

    return (
        <div className="container">
            <Button className="float-end" variant="contained" color="primary" data-bs-toggle="modal" data-bs-target="#addModal">
                {t("Add Branch")}
            </Button>

            <div className="modal fade" id="addModal" tabIndex="-1" aria-labelledby="addModalLabel" aria-hidden="true">
                {loading ? <div className="hrp-overlay"></div> : null}
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body p-3">
                            <div className=" flex-column container">
                                <form onSubmit={handleSubmit(Submit)} className="container py-2 example row g-3">
                                    <Grid className="modal-header py-2 px-0">
                                        <h5>{t("Add Branch")}</h5>
                                    </Grid>
                                    <Grid container direction="column" spacing={2}>
                                        <Grid item container spacing={3} xs={12} sm="auto" className="pt-4 mt-0">
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="text"
                                                    placeholder={t("Name")}
                                                    className={errors.name ? "is-invalid form-control" : "form-control"}
                                                    {...register("name", { required: true, pattern: regex.company_name })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="email"
                                                    placeholder={t("Email")}
                                                    className={errors.email ? "is-invalid form-control" : "form-control"}
                                                    {...register("email", { required: true, pattern: regex.email })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="text"
                                                    placeholder={t("Phone")}
                                                    className={errors.phone ? "is-invalid form-control" : "form-control"}
                                                    {...register("phone", { required: true, pattern: regex.phone })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="text"
                                                    placeholder={t("Zip Code")}
                                                    className={errors.zip_code ? "is-invalid form-control" : "form-control"}
                                                    {...register("zip_code", { pattern: regex.zip_code })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <select
                                                    className={errors.country ? "is-invalid form-select" : "form-select"}
                                                    onClick={(e) => {
                                                        setCountryValue(e.target.value);
                                                        setValue("region", "");
                                                    }}
                                                    {...register("country", { required: true })}
                                                >
                                                    <option value="">{t("Select country")}</option>
                                                    {country.map((el) => (
                                                        <option key={el.id} value={el.name}>
                                                            {el.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <input
                                                    type="text"
                                                    placeholder={t("City")}
                                                    className={errors.city ? "is-invalid form-control" : "form-control"}
                                                    {...register("city", { required: true, pattern: regex.city })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                {countryValue === "Uzbekistan" ? (
                                                    <select
                                                        className={errors.region ? "is-invalid form-select" : "form-select"}
                                                        {...register("region", { required: true })}
                                                    >
                                                        <option value="">{t("Select region")}</option>
                                                        {regions.map((el) => (
                                                            <option key={el.id} value={el.name}>
                                                                {el.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        placeholder={t("Region")}
                                                        className={errors.region ? "is-invalid form-control" : "form-control"}
                                                        {...register("region", { required: true, pattern: regex.region })}
                                                    />
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="text"
                                                    placeholder={t("Address 1")}
                                                    className={errors.address1 ? "is-invalid form-control" : "form-control"}
                                                    {...register("address1", { required: true, pattern: regex.address1 })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <input
                                                    type="text"
                                                    placeholder={t("Address 2")}
                                                    className={errors.address2 ? "is-invalid form-control" : "form-control"}
                                                    {...register("address2", { pattern: regex.address2 })}
                                                />
                                            </Grid>

                                            <Grid className="modal-footer mt-4 pt-3" item xs={12} sm={12}>
                                                <Button
                                                    className="me-3"
                                                    variant="contained"
                                                    data-bs-dismiss="modal"
                                                    ref={closeRef}
                                                    color={loading ? "inherit" : "secondary"}
                                                    onClick={() => reset()}
                                                >
                                                    {t("Cancel")}
                                                </Button>

                                                <Button
                                                    className="float-end"
                                                    disabled={loading}
                                                    color="primary"
                                                    type="submit"
                                                    variant="contained"
                                                    startIcon={loading && <CircularProgress size="0.9rem" />}
                                                >
                                                    {loading ? t("Saving") : t("Save")}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(AddBranches);
